import { CommonModule } from "@angular/common";
import { ModalResizableDirective } from "./directives/modal-resizable.directive";
import { NgModule } from "@angular/core";
import { OnlyIntegerDirective } from "./directives/only-integer.directive";

@NgModule({
  declarations: [
    ModalResizableDirective,
    OnlyIntegerDirective
  ],
  exports: [
    ModalResizableDirective,
    OnlyIntegerDirective
  ],
  imports: [
    CommonModule,
  ],
  providers: [
  ],
  schemas: [
  ]
})

export class OurDirectivesModule {
  constructor() { }
}
